export const NAME = 'audioOutput' as const;

